import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetDashboardExportReportInterface {
  startDate: string;
  endDate: string;
}

export const useGetDashboardDownloadView = () => {
  const mutate = useMutation(({ startDate, endDate }: GetDashboardExportReportInterface) => {
    return get(`/enterprise-tickets-api/export_excel_with_date_range/${startDate}/${endDate}`, {
      responseType: 'blob',
    });
  });

  return mutate;
};

export default useGetDashboardDownloadView;
